import { Box, Typography } from '@mui/material';
import { useAppContext } from 'app/AppContext';
import DataTable from 'components/DataTable';
import { fetchArray } from 'entity';
import Fazenda from 'entity/Fazenda';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useCookies } from "react-cookie"

export default function FazendaForm() {
    const navigate = useNavigate();
    const { useSetTitle, setActionsView } = useAppContext();
    const [options, setOptions] = useState([]);
    const [searchNomeFazenda, setSearchNomeFazenda] = useState("");
    const [filteredOptions, setFilteredOptions] = useMemoizedState([]);

    const [isLoading, setIsLoading] = useState(false)
    const [, setCookie] = useCookies(["fazendas"])

    function useMemoizedState(initialValue) {
        const [state, setState] = useState(initialValue);
        const memoizedState = useMemo(() => state, [state]);

        const setMemoizedState = useCallback((newState) => {
            setState(newState);
        }, []);

        return [memoizedState, setMemoizedState];
    }
    useEffect(() => {
        const actions = [
            {
                uid: "novoForm",
                text: "Novo",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/fazenda");
                },
            },

        ];

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
    }, [navigate, setActionsView]);

    useSetTitle("Fazendas");

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        setIsLoading(true)
        if (options.length === 0) {
            const result = await fetchArray(Fazenda.getAll());
            setOptions(["", ...result]);
            setFilteredOptions(["", ...result]);

            setCookie("fazendas", JSON.stringify(result.map(f => f.nome.toUpperCase())), {
                path: "/"
            })
        }
        setIsLoading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.length]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    const onChangeSearchNomeFazenda = e => {
        setSearchNomeFazenda(e.target.value)
    }

    const handleSearch = () => {
        setIsLoading(true)
        setFilteredOptions(
            options.filter(fazenda => {
                let nome;
                if (fazenda.nome?.toUpperCase().includes(searchNomeFazenda.toUpperCase())) {
                    nome = true;
                }
                return nome;
            })
        )
        setIsLoading(false)
    }


    return (

        <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
            <Box sx={{ textAlign: "center", mt: 0 }}>

                <Accordion sx={{ boxShadow: 3, mb: 1 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Filtro</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TextField
                            sx={{ width: "100%" }}
                            id="nomeFazendaTextField"
                            label="Nome da fazenda"
                            variant="standard"
                            onChange={onChangeSearchNomeFazenda}
                            value={searchNomeFazenda}
                            onKeyUp={() => handleSearch()}
                        />
                    </AccordionDetails>
                </Accordion>
            </Box>

            <DataTable
                columns={Fazenda.searchColumns}
                rows={filteredOptions}
                loading={isLoading}
                onRowClick={row => navigate("/fazenda?uid=" + row.id)}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: "rgba(145, 145, 145, 0.20);",
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: "grey",
                    },
                }}
            />
        </Box>
    )
}
